/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: content-seasonvolume-searchview-component.js
 *
 * Created by randysorensen on 7/19/17.
 */

'use strict';

function ContentSeasonVolumeSearchViewController ($location, $routeParams, uiGridConstants, ContentEditService,
												  ModalService, NotificationService, NavbarUtilService) {

	var self = this;

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};
	self.showHidden = false;


	//======//
	// Data //
	//======//

	var getData = function () {
		self.loadingIndicator.show = true;
		var serviceFunc = self.isSeason? 'getSeasons': 'getVolumes';
		self.contentObject = ContentEditService[serviceFunc](self.showHidden)
			.then(function (contentObject) {
				self.seasonVolumes = contentObject;
				self.gridOptions.data = self.seasonVolumes;
				self.gridApi.selection.clearSelectedRows();

				self.searchText = $location.search().searchText || null;
				self.filterGrid(self.searchText);

				self.loadingIndicator.show = false;
			});
	};


	//=================//
	// Lifecycle Hooks //
	//=================//

	self.$onInit = function () {
		getData();

		// Navbar search button click handler
		NavbarUtilService.viewSearchFunction = getData;
	};


	//======//
	// Grid //
	//======//

	self.gridColumnDefs = [
		{
			field: 'locked',
			type: 'boolean',
			width: 25,
			enableColumnMenu: false,
			enableSorting: true,
			cellTemplate: 'components/visual/grid/lock-icon-template.html',
			headerCellTemplate: 'components/visual/grid/header-lock-icon-template.html',
			displayName: 'Locked',
		},
		{
			field: 'name',
			type: 'string',
			width: '350',
			enableSorting: true,
			sort: {
				direction: 'asc',
				priority: 0
			},
			displayName: 'Name',
			cellTemplate: 'meta/content/editor/components/view/seasonvolume/searchView/gridTemplates/seasonvolume-name-template.html',
		},
		{
			field: 'value',
			type: 'string',
			width: '150',
			enableSorting: true,
			displayName: 'Value',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
		},
		{
			field: 'startDate',
			type: 'string',
			width: '200',
			enableSorting: true,
			displayName: 'Start Date',
			cellTemplate: 'components/visual/grid/date-column-template.html',
		},
		{
			field: 'shortDescription',
			type: 'string',
			width: '*',
			enableSorting: true,
			displayName: 'Short Description',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
		},
	];
	self.gridApi = null;
	self.gridOptions = {
		columnDefs: self.gridColumnDefs,
		data: [],
		enableRowHeaderSelection: false,
		enableSelectAll: false,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableSorting: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: uiGridConstants.ALWAYS,
		enableVerticalScrollbar: uiGridConstants.ALWAYS,
		multiSelect: false,
		onRegisterApi: function (gridApi) {
			self.gridApi = gridApi;
			self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
		},
		rowSelection: true,
		rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
	};

	self.processGridFilter = function (renderableRows) {
		renderableRows.forEach(function (row) {
			row.visible = (self.searchText === null)?
				true:
				row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
		});
		return renderableRows;
	};

	self.filterGrid = function (searchText) {
		if (searchText !== null) {
			self.searchText = searchText.toLowerCase();
			self.gridApi.grid.refresh();
		}
	};

	var getSelectedCount = function () {
		return self.gridApi.selection.getSelectedCount();
	};

	var getSelectedEntity = function () {
		return self.gridApi.selection.getSelectedRows()[0];
	};


	//=========//
	// Actions //
	//=========//

	var newSeasonVolume = function () {
		$location.url('/meta/series/edit/' + $routeParams.id + '/' +
			(self.isSeason? 'seasons': 'volumes') + '/edit/-1/properties');
	};

	var editSeasonVolume = function (seasonVolume) {
		var entityType = self.isSeason? 'Season': 'Volume';
		if (seasonVolume.hidden) {
			NotificationService.createWarningNotification(entityType + ' is hidden');
		} else {
			$location.url('/meta/series/edit/' + $routeParams.id + '/' +
				(self.isSeason? 'seasons': 'volumes') + '/edit/' + seasonVolume.id + '/properties');
		}
	};

	var openConfirmationModal = function (action, resultHandler) {
		var entityType = self.isSeason? 'Season': 'Volume';
		var seasonVolumeName = getSelectedEntity().name;
		ModalService.showMessageModal({
			messageText: 'Are you sure you want to ' + action + ' ' + seasonVolumeName + '?',
			title: (action.charAt(0).toUpperCase() + action.slice(1)) + entityType,
			showOK: true,
			okText: 'Yes',
			cancelText: 'No',
			pullCancelLeft: true,
			windowClass: 'confirm-modal-sm'
		}, resultHandler);
	};

	var cloneSelectedSeasonVolume = function () {
		var serviceCloneFunction = self.isSeason? 'cloneSeason': 'cloneVolume';
		ContentEditService[serviceCloneFunction](getSelectedEntity()).then(function () {
			getData();
		});
	};

	var toggleSelectedSeasonVolumeVisibility = function () {
		var serviceToggleFunction = self.isSeason? 'toggleSeasonVisibility': 'toggleVolumeVisibility';
		ContentEditService[serviceToggleFunction](getSelectedEntity()).then(function () {
			getData();
		});
	};

	var isSelectedSeasonVolumeHidden = function () {
		var seasonVolume = getSelectedEntity();
		return !!seasonVolume && seasonVolume.hidden;
	};

	self.onRowDblClick = function (row) {
		editSeasonVolume(row.entity);
	};


	//=========//
	// Toolbar //
	//=========//

	self.toolbarButtonDefs = [
		{
			label: 'New',
			enabled: function () { return true; },
			onClick: function () { newSeasonVolume(); },
		},
		{
			label: 'Edit',
			enabled: function () { return self.gridApi.selection.getSelectedCount() === 1; },
			onClick: function () { editSeasonVolume(getSelectedEntity()); },
		},
		{
			label: 'Clone',
			enabled: function () { return self.gridApi.selection.getSelectedCount() === 1; },
			onClick: function () { openConfirmationModal('Clone', cloneSelectedSeasonVolume); },
		},
		{
			label: 'Hide',
			enabled: function () { return getSelectedCount() === 1 && !isSelectedSeasonVolumeHidden(); },
			onClick: function () { openConfirmationModal('Hide', toggleSelectedSeasonVolumeVisibility); },
		},
		{
			label: 'Unhide',
			enabled: function () { return getSelectedCount() === 1 && isSelectedSeasonVolumeHidden(); },
			onClick: function () { openConfirmationModal('Unhide', toggleSelectedSeasonVolumeVisibility); },
		}
	];

	self.toolbarCheckboxDefs = [
		{
			label: 'Show Hidden',
			onUpdate: function (newState) {
				self.showHidden = newState;
				getData();
			},
		}
	];
}

angular
	.module('prism-ui.content')
	.component('contentSeasonVolumeSearchView', {
		bindings: {
			isSeason: '<',
		},
		controller: ContentSeasonVolumeSearchViewController,
		templateUrl: 'meta/content/editor/components/view/seasonvolume/searchView/content-seasonvolume-searchview-template.html'
	})
	.filter('seasonVolumeNameFilter', function () {
		return function (name, grid) {
			var startYear = (new Date(grid.row.entity.startDate)).getFullYear();
			var endYear = (new Date(grid.row.entity.endDate)).getFullYear();
			var nameString = name;

			if (startYear) {
				nameString += ' (' + startYear;
				if (endYear) {
					nameString += ' - ' + endYear;
				}
				nameString += ')';
			}

			return nameString;
		};
	});
